(function () {
  function initTypewriter(root) {
    var el = root.querySelector('[data-lbx-stores-typewriter]');
    if (!el || el.dataset.lbxStoresTypewriterReady === 'true') return;
    el.dataset.lbxStoresTypewriterReady = 'true';

    var words = (el.getAttribute('data-words') || '').split('|').map(function (word) { return word.trim(); }).filter(Boolean);
    if (!words.length) return;

    var index = 0;
    var charIndex = words[0].length;
    var deleting = false;
    var pause = 0;

    function tick() {
      var word = words[index] || '';

      if (pause > 0) {
        pause -= 1;
      } else if (!deleting) {
        charIndex += 1;
        if (charIndex >= word.length) {
          charIndex = word.length;
          deleting = true;
          pause = 18;
        }
      } else {
        charIndex -= 1;
        if (charIndex <= 0) {
          charIndex = 0;
          deleting = false;
          index = (index + 1) % words.length;
          pause = 4;
        }
      }

      el.textContent = word.slice(0, charIndex) || ' ';
      window.setTimeout(tick, deleting ? 42 : 64);
    }

    window.setTimeout(tick, 900);
  }

  function initMarquee(root) {
    var marquee = root.querySelector('[data-lbx-stores-marquee]');
    if (!marquee || marquee.dataset.lbxStoresMarqueeReady === 'true') return;
    marquee.dataset.lbxStoresMarqueeReady = 'true';

    var track = marquee.querySelector('[data-lbx-stores-marquee-track]');
    if (!track) return;

    var speed = parseFloat(marquee.getAttribute('data-speed') || '75');
    var x = 0;
    var last = performance.now();

    track.innerHTML = track.innerHTML + track.innerHTML;

    function frame(now) {
      var dt = Math.min(42, now - last) / 1000;
      last = now;
      var halfWidth = track.scrollWidth / 2;
      x -= speed * dt;
      if (Math.abs(x) >= halfWidth) x += halfWidth;
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
      requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  function initReveal(root) {
    var items = root.querySelectorAll('.lbx-stores-reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });

    items.forEach(function (item) { observer.observe(item); });
  }

  function initFilters(root) {
    var buttons = root.querySelectorAll('[data-lbx-store-filter]');
    var cards = root.querySelectorAll('[data-lbx-store-card]');
    if (!buttons.length || !cards.length) return;

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var filter = button.getAttribute('data-lbx-store-filter') || 'all';
        buttons.forEach(function (btn) { btn.classList.toggle('is-active', btn === button); });
        cards.forEach(function (card) {
          var rawCategories = card.getAttribute('data-store-categories') || card.getAttribute('data-store-kind') || 'store';
          var categories = rawCategories.split(/\s+/).filter(Boolean);
          card.classList.toggle('is-hidden', filter !== 'all' && categories.indexOf(filter) === -1);
        });
      });
    });
  }



  function initMapPins(root) {
    var frame = root.querySelector('[data-lbx-stores-map-frame]');
    if (!frame || frame.dataset.lbxStoresMapPinsReady === 'true') return;
    frame.dataset.lbxStoresMapPinsReady = 'true';

    var canvas = frame.querySelector('[data-lbx-stores-map-canvas]') || frame;
    var pins = frame.querySelectorAll('[data-lbx-stores-map-pin]');
    var popover = frame.querySelector('[data-lbx-stores-map-popover]');
    if (!pins.length || !popover) return;

    function updateMapCanvasScale() {
      if (!canvas || canvas === frame) return;
      var referenceWidth = parseFloat(canvas.getAttribute('data-map-reference-width') || '1200');
      var referenceHeight = parseFloat(canvas.getAttribute('data-map-reference-height') || '720');
      var rect = frame.getBoundingClientRect();
      if (!rect.width || !rect.height || !referenceWidth || !referenceHeight) return;
      var scale = Math.min(rect.width / referenceWidth, rect.height / referenceHeight);
      frame.style.setProperty('--lbx-map-scale', scale.toFixed(5));
    }

    updateMapCanvasScale();
    window.requestAnimationFrame(updateMapCanvasScale);
    window.setTimeout(updateMapCanvasScale, 250);

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(updateMapCanvasScale);
      resizeObserver.observe(frame);
    } else {
      window.addEventListener('resize', updateMapCanvasScale, { passive: true });
    }

    var nameEl = popover.querySelector('[data-lbx-stores-map-name]');
    var cityEl = popover.querySelector('[data-lbx-stores-map-city]');
    var typeEl = popover.querySelector('[data-lbx-stores-map-type]');
    var addressEl = popover.querySelector('[data-lbx-stores-map-address]');
    var phoneEl = popover.querySelector('[data-lbx-stores-map-phone]');
    var linkEl = popover.querySelector('[data-lbx-stores-map-link]');
    var closeEl = popover.querySelector('[data-lbx-stores-map-close]');
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    function openPin(pin) {
      pins.forEach(function (item) { item.classList.toggle('is-active', item === pin); });
      if (nameEl) nameEl.textContent = pin.getAttribute('data-store-name') || '';
      if (cityEl) cityEl.textContent = pin.getAttribute('data-store-city') || '';
      if (typeEl) typeEl.textContent = pin.getAttribute('data-store-type') || 'Punto LaBosch';
      if (addressEl) addressEl.textContent = pin.getAttribute('data-store-address') || '';
      if (phoneEl) phoneEl.textContent = pin.getAttribute('data-store-phone') || '';
      if (linkEl) {
        var url = pin.getAttribute('data-store-url') || '#';
        linkEl.href = url || '#';
        linkEl.style.display = url ? '' : 'none';
      }
      popover.hidden = false;
    }

    function getHelper() {
      var helper = frame.querySelector('[data-lbx-stores-pin-helper]');
      if (helper) return helper;
      helper = document.createElement('div');
      helper.className = 'lbx-stores-pin-helper';
      helper.setAttribute('data-lbx-stores-pin-helper', '');
      helper.innerHTML = '<p class="lbx-stores-pin-helper__title"><span>Modo editor · posición punto</span></p><div class="lbx-stores-pin-helper__coords"><span><strong>X</strong><b data-pin-x>--</b></span><span><strong>Y</strong><b data-pin-y>--</b></span></div><p class="lbx-stores-pin-helper__note">Arrastra el punto. Luego copia estos valores en el bloque de la tienda: “Posición X en mapa (%)” y “Posición Y en mapa (%)”.</p><button type="button" class="lbx-stores-pin-helper__copy" data-pin-copy>Copiar X/Y</button>';
      helper.hidden = true;
      frame.appendChild(helper);
      return helper;
    }

    function updateHelper(pin, x, y) {
      var helper = getHelper();
      var xText = helper.querySelector('[data-pin-x]');
      var yText = helper.querySelector('[data-pin-y]');
      var copy = helper.querySelector('[data-pin-copy]');
      var xValue = String(Math.max(0, Math.min(100, x)).toFixed(1));
      var yValue = String(Math.max(0, Math.min(100, y)).toFixed(1));
      helper.hidden = false;
      if (xText) xText.textContent = xValue + '%';
      if (yText) yText.textContent = yValue + '%';
      if (copy) {
        copy.onclick = function () {
          var text = 'X: ' + xValue + ' / Y: ' + yValue;
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).catch(function () {});
          }
          copy.textContent = 'Copiado';
          window.setTimeout(function () { copy.textContent = 'Copiar X/Y'; }, 1100);
        };
      }
    }

    function initDrag(pin) {
      if (!designMode || pin.dataset.lbxStoresPinDragReady === 'true') return;
      pin.dataset.lbxStoresPinDragReady = 'true';
      var moved = false;
      var dragging = false;

      function move(clientX, clientY) {
        var rect = canvas.getBoundingClientRect();
        var x = ((clientX - rect.left) / rect.width) * 100;
        var y = ((clientY - rect.top) / rect.height) * 100;
        x = Math.max(0, Math.min(100, x));
        y = Math.max(0, Math.min(100, y));
        pin.style.setProperty('--pin-x', x.toFixed(1) + '%');
        pin.style.setProperty('--pin-y', y.toFixed(1) + '%');
        updateHelper(pin, x, y);
      }

      pin.addEventListener('pointerdown', function (event) {
        dragging = true;
        moved = false;
        pin.classList.add('is-dragging');
        pin.setPointerCapture && pin.setPointerCapture(event.pointerId);
        event.preventDefault();
        event.stopPropagation();
      });

      pin.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        moved = true;
        move(event.clientX, event.clientY);
        event.preventDefault();
        event.stopPropagation();
      });

      function endDrag(event) {
        if (!dragging) return;
        dragging = false;
        pin.classList.remove('is-dragging');
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        window.setTimeout(function () { moved = false; }, 80);
      }

      pin.addEventListener('pointerup', endDrag);
      pin.addEventListener('pointercancel', endDrag);

      pin.addEventListener('click', function (event) {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
    }

    pins.forEach(function (pin) {
      initDrag(pin);
      pin.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (designMode && pin.classList.contains('is-dragging')) return;
        openPin(pin);
      });
    });

    if (closeEl) {
      closeEl.addEventListener('click', function () {
        popover.hidden = true;
        pins.forEach(function (item) { item.classList.remove('is-active'); });
      });
    }
  }


  function initDeferredMaps(root) {
    var frames = root.querySelectorAll('iframe[data-lbx-defer-map]');
    if (!frames.length) return;

    var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 760px)') : { matches: false };

    function shouldSkip(frame) {
      return mobileQuery.matches && !!frame.closest('.lbx-stores-map-panel');
    }

    function loadFrame(frame) {
      if (!frame || frame.dataset.lbxMapLoaded === 'true' || shouldSkip(frame)) return;
      var src = frame.getAttribute('data-src');
      if (!src) return;
      frame.src = src;
      frame.dataset.lbxMapLoaded = 'true';
      var holder = frame.closest('.lbx-stores-map-panel__frame, .lbx-store-card__map');
      if (holder) holder.classList.add('is-map-loaded');
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadFrame(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '520px 0px', threshold: 0.01 });

      frames.forEach(function (frame) {
        if (shouldSkip(frame)) return;
        observer.observe(frame);
      });

      var onChange = function () {
        frames.forEach(function (frame) {
          if (frame.dataset.lbxMapLoaded === 'true') return;
          if (shouldSkip(frame)) return;
          observer.observe(frame);
        });
      };

      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onChange);
      else if (mobileQuery.addListener) mobileQuery.addListener(onChange);
    } else {
      frames.forEach(loadFrame);
    }
  }

  function initSection(root) {
    if (!root || root.dataset.lbxStoresReady === 'true') return;
    root.dataset.lbxStoresReady = 'true';
    initTypewriter(root);
    initMarquee(root);
    initReveal(root);
    initFilters(root);
    initDeferredMaps(root);
    initMapPins(root);
  }

  function initAll() {
    document.querySelectorAll('[data-lbx-stores]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-lbx-stores]') : null;
    initSection(root);
  });
})();
